import { useQuery } from "@tanstack/react-query";
import { payTypesQuery } from "../../../../../api/index.js";
import { useMemo } from "react";

// Map pay type options for react-select based on integration
export const usePayTypeOptions = (integration, scope) => {
  const { data } = useQuery(payTypesQuery(integration, scope));

  return useMemo(
    () =>
      data?.map((mapping) => ({
        value: mapping.code,
        label: integration === "PROCOUNTOR" ? `${mapping.code} ${mapping.name}` : mapping.name,
        payrollSystemType: mapping.payrollSystemType,
      })) || [],
    [data, integration],
  );
};
